import { createObjectURL } from "../../core/BlobUtils";
export class BlobsController {
  constructor(poly) {
    this.poly = poly;
    this._blobWrappersByUrl = /* @__PURE__ */ new Map();
  }
  recording() {
    return !this.poly.playerMode();
  }
  blobUrl(url) {
    var _a;
    return (_a = this._blobWrappersByUrl.get(url)) == null ? void 0 : _a.blobUrl;
  }
  clear() {
    this._blobWrappersByUrl.clear();
  }
  clearBlobsForNode(node) {
    const urls = [];
    const nodeId = node.graphNodeId();
    this._blobWrappersByUrl.forEach((blobWrapper, url) => {
      if (blobWrapper.referringNodeIds.has(nodeId)) {
        urls.push(url);
      }
    });
    for (let url of urls) {
      const wrapper = this._blobWrappersByUrl.get(url);
      if (wrapper) {
        if (wrapper.referringNodeIds.size == 1) {
          this._blobWrappersByUrl.delete(url);
        } else {
          wrapper.referringNodeIds.delete(nodeId);
        }
      }
    }
  }
  _assignBlobToNode(url, node, blobWrapper, options = {}) {
    if (options.multiAssetsForNode != true) {
      this.clearBlobsForNode(node);
    }
    const currentBlobWrapper = this._blobWrappersByUrl.get(url);
    if (currentBlobWrapper) {
      currentBlobWrapper.referringNodeIds.add(node.graphNodeId());
    } else {
      this._blobWrappersByUrl.set(url, blobWrapper);
    }
  }
  async setVirtualFile(file, uniqueId) {
    const blob = file;
    const blobWrapper = {
      blob,
      blobUrl: this._createBlobUrl(file),
      referringNodeIds: /* @__PURE__ */ new Set()
    };
    this._blobWrappersByUrl.set(uniqueId, blobWrapper);
  }
  async fetchBlobGlobal(url) {
    if (!this.recording()) {
      return {};
    }
    try {
      const existingBlobWrapper = this._blobWrappersByUrl.get(url);
      if (existingBlobWrapper) {
        return { blobWrapper: existingBlobWrapper };
      }
      const remapedUrl = this.poly.assetUrls.remapedUrl(url) || url;
      const response = await fetch(remapedUrl);
      if (response.ok) {
        const blob = await response.blob();
        const blobWrapper = {
          blob,
          blobUrl: this._createBlobUrl(blob),
          referringNodeIds: /* @__PURE__ */ new Set()
        };
        this._blobWrappersByUrl.set(url, blobWrapper);
        return {
          blobWrapper
        };
      } else {
        return { error: `failed to fetch ${remapedUrl}` };
      }
    } catch (err) {
      return { error: `failed to fetch ${url}` };
    }
  }
  async fetchBlobForNode(options) {
    if (!this.recording()) {
      return {};
    }
    try {
      const nodeId = options.node.graphNodeId();
      const existingBlobWrapper = this._blobWrappersByUrl.get(options.fullUrl);
      if (existingBlobWrapper) {
        existingBlobWrapper.referringNodeIds.add(nodeId);
        return { blobWrapper: existingBlobWrapper };
      }
      const remapedUrl = this.poly.assetUrls.remapedUrl(options.fullUrl) || options.fullUrl;
      const response = await fetch(remapedUrl);
      if (response.ok) {
        const blob = await response.blob();
        const referringNodeIds = /* @__PURE__ */ new Set();
        referringNodeIds.add(nodeId);
        const blobWrapper = {
          blob,
          blobUrl: this._createBlobUrl(blob),
          referringNodeIds
        };
        this._assignBlobToNode(options.fullUrl, options.node, blobWrapper, {
          multiAssetsForNode: options.multiAssetsForNode
        });
        return {
          blobWrapper
        };
      } else {
        return { error: `failed to fetch ${options.fullUrl}` };
      }
    } catch (err) {
      return { error: `failed to fetch ${options.fullUrl}` };
    }
  }
  traverse(callback) {
    const _forEachBlob = (urls2, isGlobal) => {
      this._blobWrappersByUrl.forEach((blobWrapper, url) => {
        const isWrapperGlobal = blobWrapper.referringNodeIds.size == 0;
        if (isWrapperGlobal == isGlobal) {
          urls2.push(url);
        }
      });
    };
    const urls = [];
    _forEachBlob(urls, true);
    _forEachBlob(urls, false);
    urls.sort();
    for (let url of urls) {
      const blobWrapper = this._blobWrappersByUrl.get(url);
      if (blobWrapper) {
        const blobData = {
          url,
          blobWrapper
        };
        callback(blobData);
      }
    }
  }
  _createBlobUrl(blob) {
    return createObjectURL(blob);
  }
  assetsManifestWithBlobsMap() {
    const manifest = {};
    const blobsMap = /* @__PURE__ */ new Map();
    const blobs = [];
    const fullUrls = [];
    this.traverse((blobData) => {
      blobs.push(blobData.blobWrapper.blob);
      const fullUrl = blobData.url;
      fullUrls.push(fullUrl);
    });
    for (let i = 0; i < blobs.length; i++) {
      const paramUrl = fullUrls[i];
      const blob = blobs[i];
      const assetShortName = paramUrl.split("?")[0];
      const elements = paramUrl.split(".");
      const ext = elements[elements.length - 1];
      const assignedName = `${i}.${ext}`;
      const fileNameInZip = `assets/${assignedName}`;
      blobsMap.set(fileNameInZip, blob);
      manifest[assetShortName] = assignedName;
    }
    return {
      manifest,
      blobsMap
    };
  }
}
